import { CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';

export const WaitDialog = (props) => {
    const [open, setOpen] = React.useState(props.show);

    const handleClose = () => {
      setOpen(false);
    };
  
    return (
      <div >
        <Dialog 
          open={open}
          onClose={handleClose}
          disableEscapeKeyDown
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description" 
        >
          <DialogTitle id="alert-dialog-title" >
            {"Por favor, espere..."}
          </DialogTitle>
          <DialogContent sx={{
                        margin: 2,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}>
              <CircularProgress />
          </DialogContent>
        </Dialog>
      </div>
    );
};
